import keyMirror from 'keymirror';

export const learningPathActionTypes = keyMirror({
	TOGGLE_LEARNING_PATH_CREATE_MODAL: null,
	GET_LEARNING_PATH_OPTIONS: null,
	GET_LEARNING_PATH_OPTIONS_SUCCESS: null,
	GET_LEARNING_PATH_OPTIONS_ERROR: null,
	CREATE_LEARNING_PATH: null,
	CREATE_LEARNING_PATH_SUCCESS: null,
	CREATE_LEARNING_PATH_ERROR: null,
	MANAGE_LEARNING_PATH_STEP: null,
	MANAGE_LEARNING_PATH_STEP_FINAL: null,
	CLOSE_LEARNING_PATH: null,
	CLOSE_LEARNING_PATH_FINAL: null,
	CLEAR_LEARNING_PATH_MODAL_STATE: null,
});
